export enum FlyoutSizesEnum {
  Small = 'Small',
  Medium = 'Medium',
}

export type FlyoutSizesType = keyof typeof FlyoutSizesEnum;
